<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Search Judgments</h2>
  </div>
</nz-card>

<nz-card class="!my-4">
  <div class="flex flex-col gap-4">
    <!-- Search Input -->
    <div class="relative w-full">
      <nz-input-group nzSearch [nzSuffix]="inputClearTpl" nzSize="large">
        <input
          type="text"
          nz-input
          [(ngModel)]="searchVal"
          (keypress)="handleKeyPress($event)"
          [placeholder]="searchField === 'all' ? 'Enter search term' : 'Enter ' + getFieldLabel().toLowerCase()" />
      </nz-input-group>
      <ng-template #inputClearTpl>
        <span
          nz-icon
          class="ant-input-clear-icon"
          nzTheme="fill"
          nzType="close-circle"
          *ngIf="searchVal"
          (click)="clearSearch()"></span>
      </ng-template>
    </div>

    <!-- Filter By Section with Radio Buttons -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div class="flex flex-col gap-2 w-full md:w-auto">
        <label class="text-[#441752] font-semibold text-xs sm:text-sm">Filter By:</label>
        <nz-radio-group [(ngModel)]="searchField" nzSize="large" class="flex flex-wrap gap-2 sm:gap-4">
          <label *ngFor="let field of searchFields" nz-radio [nzValue]="field.value" class="mr-0 sm:mr-4 text-xs sm:text-sm">
            {{ field.label }}
          </label>
        </nz-radio-group>
      </div>

      <!-- Submit Button -->
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        (click)="search()"
        class="px-4 sm:px-6 w-full md:w-auto">
        Submit
      </button>
    </div>
  </div>
</nz-card>

<nz-card class="!my-4" *ngIf="hasSearched">
  <div class="py-3 md:py-4">
    <p class="text-[#441752] font-normal text-sm sm:text-base">
      Showing Results for "<strong>{{ searchVal }}</strong>" in
      <strong>{{ getFieldLabel() }}</strong> ({{ data.length }} result{{ data.length !== 1 ? 's' : '' }})
    </p>
  </div>
</nz-card>

<nz-empty class="mt-10" *ngIf="hasSearched && data.length === 0"></nz-empty>

<nz-card class="!my-4" *ngIf="hasSearched && data.length > 0">
  <div class="overflow-x-auto" style="scrollbar-width: thin;">
    <nz-table
      [nzData]="data"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      nzSize="middle"
      [nzScroll]="{ x: '1000px' }">
      <thead>
        <tr>
          <th nzWidth="120px">Case No</th>
          <th nzWidth="120px" class="hidden md:table-cell">Date</th>
          <th nzWidth="200px" class="hidden lg:table-cell">Parties</th>
          <th nzWidth="150px" class="hidden lg:table-cell">Judgment By</th>
          <th nzWidth="200px" class="hidden xl:table-cell">Summary</th>
          <th nzWidth="120px" class="text-center">Document</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let judgment of data">
          <td class="font-medium text-[#441752]">{{ judgment.caseNo || 'N/A' }}</td>
          <td class="hidden md:table-cell">{{ formatDate(judgment.dateOfJudgment) }}</td>
          <td class="hidden lg:table-cell">{{ judgment.namesOfParties || 'N/A' }}</td>
          <td class="hidden lg:table-cell">{{ judgment.judgmentBy || 'N/A' }}</td>
          <td class="hidden xl:table-cell">
            <span class="block">{{ judgment.summary || 'N/A' }}</span>
          </td>
          <td>
            <div class="flex flex-col items-center">
              <a
                *ngIf="getFileUrl(judgment.document) !== '#'"
                [href]="getFileUrl(judgment.document)"
                target="_blank"
                nz-button
                nzSize="small"
                nzType="primary">
                Download
              </a>
              <span
                *ngIf="getFileUrl(judgment.document) === '#'"
                class="text-gray-400 text-sm">
                No document
              </span>
              <!-- Mobile view: show additional info -->
              <div class="md:hidden mt-2 text-left space-y-1 text-xs text-gray-600 w-full">
                <div><strong>Date:</strong> {{ formatDate(judgment.dateOfJudgment) }}</div>
                <div><strong>Parties:</strong> {{ judgment.namesOfParties || 'N/A' }}</div>
                <div><strong>By:</strong> {{ judgment.judgmentBy || 'N/A' }}</div>
                <div *ngIf="judgment.summary"><strong>Summary:</strong> <span>{{ judgment.summary }}</span></div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-card>

<div class="mt-4 flex justify-center sm:justify-end" *ngIf="hasSearched && data.length > 0">
  <nz-pagination
    class="mt-4 sm:mt-8"
    (nzPageIndexChange)="onCurrentPageDataChange($event)"
    [nzPageIndex]="currentPage"
    [nzTotal]="totalDocs"
    [nzPageSize]="pageSize"
    [nzSimple]="false"
    [nzShowSizeChanger]="false"
    nzSize="small"></nz-pagination>
</div>




